var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[(_vm.$mq !== 'sm')?_c('cg-event-filter'):_vm._e(),_c('cg-event-teaser-list'),_c('cg-misc')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }